export const pt = {
  brand: 'DeytanPlay',
  tagline: 'Jogos rápidos no celular — divirta-se e desafie amigos.',
  heroTitle: 'Escolha um jogo',
  heroSubtitle: 'Portal leve, mobile-first. Sem download.',
  playNow: 'Jogar',
  comingSoon: 'Em breve',
  newBadge: 'Novo',
  backHome: 'Voltar',
  themeSystem: 'Sistema',
  themeLight: 'Claro',
  themeDark: 'Escuro',
  language: 'Idioma',
  privacy: 'Privacidade',
  terms: 'Termos',
  footerNote: 'Feito com ☕ pela DeytanLab',
  privacyStub: 'Política de privacidade em breve.',
  termsStub: 'Termos de uso em breve.',

  gameWordleTitle: 'Wordle',
  gameWordleDescription: 'Descubra a palavra em poucas tentativas e desafie um amigo.',

  wordleMenuTitle: 'Wordle',
  wordleMenuSubtitle: 'Escolha tamanho e dicionário antes de jogar. Tentativas = tamanho + 1.',
  wordleLengthLabel: 'Tamanho da palavra',
  wordleLengthHint: '{length} letras · {attempts} tentativas',
  wordleGameLangLabel: 'Dicionário do jogo',
  wordleDictPt: 'Português',
  wordleDictEn: 'Inglês',
  wordleDictBadge: 'Dicionário: {dict}',
  wordlePlayRandom: 'Jogar aleatório',
  wordleCreateChallenge: 'Criar desafio',
  wordleCustomWord: 'Palavra do desafio',
  wordleCustomPlaceholder: 'Ex.: PORTA',
  wordleOptionalNick: 'Seu apelido (opcional)',
  wordleNickPlaceholder: 'Ex.: Ana',
  wordleCreateLink: 'Gerar link do desafio',
  wordleInvalidCustom: 'Use apenas letras A–Z, de 4 a 8 caracteres.',
  wordleNotInDictionary: 'Palavra não está no dicionário.',
  wordleTooShort: 'Complete a palavra.',
  wordleAlreadyGuessed: 'Você já tentou essa palavra.',
  wordleEnter: 'ENTER',
  wordleBack: '⌫',
  wordleWon: 'Acertou em {attempts} tentativa(s)!',
  wordleLost: 'A palavra era {word}.',
  wordleShareChallenge: 'Desafiar amigo',
  wordleShareResult: 'Compartilhar resultado',
  wordleCounterChallenge: 'Desafiar de volta',
  wordleCounterRandom: 'Desafio aleatório',
  wordleCounterCustom: 'Desafio customizado',
  wordleNewGame: 'Novo jogo',
  wordleInvalidLink: 'Este link de desafio é inválido.',
  wordleChallengeFrom: '{name} te desafiou!',
  wordleChallengeFromAnon: 'Alguém te desafiou!',
  wordleChallengerResult: 'Resolveu em {attempts} tentativa(s).',
  wordleChallengerLost: 'Não acertou — consegue melhor?',
  wordleShareTextChallenge: 'Te desafiei no DeytanPlay Wordle! Palavra de {length} letras. Consegue?',
  wordleShareTextResult: 'Resolvi o Wordle do DeytanPlay em {attempts} tentativa(s)!',
  wordleShareTextCounter: 'Consegui! Agora te desafio de volta no DeytanPlay Wordle.',
  wordleCopyLink: 'Link copiado!',
  wordleShareFailed: 'Não foi possível compartilhar. Tente copiar o link.',
  wordleLoadingDict: 'Carregando dicionário…',
  wordleAttemptsLeft: '{n} tentativa(s) restante(s)',
} as const;

export type MessageKey = keyof typeof pt;
